'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asyncValidate = exports.validate = undefined;

var _revalidate = require('revalidate');

var _vat = require('redux/modules/vat');

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var validate = exports.validate = (0, _revalidate.combineValidators)({
  name: (0, _revalidate.isRequired)({ message: 'This is who will be invoiced' }),
  postalCode: (0, _revalidate.isRequired)({ message: 'Postal code is required' })
});

var asyncValidate = exports.asyncValidate = function asyncValidate(values, dispatch) {
  if (!values.vatNo || !values.vatNo.length) {
    return _bluebird2.default.resolve();
  }
  if (values.isVatValid === false) {
    return { vatNo: 'We are unable to verify your VAT ID' };
  }

  return dispatch((0, _vat.validateVat)({ vatNo: values.vatNo })).then(function (response) {
    if (response.vatNo == values.vatNo) {
      return null;
    }
  }).catch(function (err) {
    if (err) {
      return {
        vatNo: 'We are unable to verify your VAT ID'
      };
    }
  });
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/addressFormValidation.js
// module id = 2810
// module chunks = 0